<template>
  <a-layout class='index animated fadeIn s_bf'>
    <SmallSquare content='二维码（一物一码）默认为启用状态，通过空码赋值、动态调整可以给二维码赋予各种基于线下场景的扫码营销活动' :padding='false' v-if='type=="normal"'></SmallSquare>
    <SmallSquare content='对丢失的二维码数据进行禁用管理，禁用后用户扫码将提示不存在' :padding='false' v-else></SmallSquare>
    <div class="m-t-20 s_flex_bian_c" v-if='type=="ban"'>
      <div>
        <span class='mr15'>
          <a-button type="primary" v-has:qrcodeBatchAddDisable="addBanBatch">
            <PlusOutlined />
            添加禁用
          </a-button>
        </span>
      </div>
    </div>
    <a-form ref='form' :model='search' class="m-t-20" :style="{'marginBottom':'10px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="添加时间" name='time'>
        <a-range-picker valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD  ' @change="changTime" />
      </a-form-item>
      <a-form-item label="批次" name='batch_sn'>
        <a-input v-model:value="search.batch_sn" style="width:200px" placeholder="请输入批次号进行搜索"></a-input>
      </a-form-item>
      <!-- <normalBatchs v-model:value="search.batch_sn" type='select' mode="" /> -->
      <!-- <a-form-item label="应用场景" name='app_type' v-if='type=="normal"'>
          <a-select v-model:value="search.app_type" :style="{width:'140px'}">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">智能营销码</a-select-option>
            <a-select-option :value="2">动销码</a-select-option>
            <a-select-option :value="3">导购码</a-select-option>
          </a-select>
        </a-form-item> -->
      <a-form-item>
        <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
        <a-button v-has:qrcodeBatchDown="exportTable" class='m-r-10' v-if='type != "normal"'>下载模板</a-button>
        <a-button v-has:qrcodeBatchImport="()=>{visibleTemplate=true}" class='m-r-10' v-if='type != "normal"'>导入模板</a-button>
        <!-- <a-button type="primary" v-has:qrcodeBatchSynchro="asyncBatch" class='m-r-10' v-if='type == "normal"'>同步数据</a-button> -->
      </a-form-item>
    </a-form>
    <div class='m-t-20'>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:action="{ record }">
          <a-button v-has:qrcodeBatchDelDisable="()=>open(record)" type="danger" size="small" href="javascript:;" >启用</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" :show-total="total => `总数: ${total} `" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
    </div>
  </a-layout>
  <!-- 禁用 -->
  <a-modal :keyboard="false" title="禁用管理" centered v-model:visible="banVisible" :confirm-loading="confirmLoading" @ok="banConfirm">
    <a-form ref='form' :model='banForm' class="m-t-20" :labelCol="{span:4}" :wrapper-col="{ span: 18 }" :initialValues="banForm">
      <codeBatchs v-model:value="banForm.batch_sn" type="select" label="可选批次" required v-on:change="batchChange" v-if="banVisible" />
      <a-form-item label="禁用" name='forbid_type' v-if="banForm.batch_sn">
        <a-radio-group name="forbid_type" v-model:value="banForm.forbid_type">
          <a-radio :value="1">整批禁用</a-radio>
          <a-radio :value="2">按二维码流水号禁用</a-radio>
        </a-radio-group>
        <div v-if="banForm.forbid_type===2">
          <a-form-item label="批次" :labelCol="{span:6}">
            {{batch.batch_sn}}
          </a-form-item>
          <a-form-item label="总流水号" :labelCol="{span:6}">
            {{batch.small_serial_start}}-{{batch.small_serial_end}}
          </a-form-item>
          <a-form-item label="流水号区间" :labelCol="{span:6}">
            <batchInterval :small_serial_start="batch.small_serial_start" :small_serial_end="batch.small_serial_end" v-model:start="banForm.small_serial_start" v-model:end="banForm.small_serial_end" />
          </a-form-item>
          <a-form-item label="区间数量" :labelCol="{span:6}" v-if="banForm.small_serial_end">
            {{banForm.small_serial_end-banForm.small_serial_start +1}}
          </a-form-item>
        </div>
      </a-form-item>
      <a-form-item label="备注" name='remarks' required>
        <a-textarea v-model:value="banForm.remarks" placeholder="" allow-clear />
      </a-form-item>
    </a-form>
  </a-modal>
  <a-modal :keyboard="false" centered title="导入模板" v-model:visible="visibleTemplate" :width='800' :footer="null" destroyOnClose>
    <a-card :bordered="false">
      <a-upload-dragger v-model:fileList="fileList" name="forbid_file" :multiple="false" :action="action" :headers="
            {
               Authorization:getToken()
            }" @change="handleChange">
        <p class="ant-upload-drag-icon">
          <inbox-outlined></inbox-outlined>
        </p>
        <p class="ant-upload-text">点击上传或者拖拽上传</p>
      </a-upload-dragger>
    </a-card>
  </a-modal>
  <a-modal :keyboard="false" centered title="导入结果" v-model:visible="exportResultVisible" :width='800' @ok="exportResultVisible=false" destroyOnClose>
    <div>
      本次导入{{exportResult.total}}条，成功{{exportResult.success_total}}条，失败<span style="color:#f04635">{{exportResult.error_total}}</span> 条
    </div>
    <div v-if="exportResult.error_data&&exportResult.error_data.length">
      <p class="s_font_b s_fonts24 m-t-5 m-b-5">异常流水号</p>
      <a-table bordered :columns='exportColumns' :data-source='exportResult.error_data'>
      </a-table>
    </div>
  </a-modal>

</template> 
<script>
import { PlusOutlined, InboxOutlined } from "@ant-design/icons-vue";
import { reactive, ref, toRefs, onMounted, h,inject } from "vue";
import { iscode } from "@/utils/app";
import { verifyBatch, getToken } from "@/libs/util.js";
import {
  code_batchs,
  codeBatchsforbids,
  codeBatchsforbidsStatus,
  createforbids,
  codeBatchsSync,
  codeBatchsforbidsTemplate,
  exportCodeBatchsforbidsTemplate,
} from "@/api/qrcode";
import { message, Modal } from "ant-design-vue";
const def = {
  page: 1,
  limit: 10,
  app_type: "",
  batch_sn: "",
  start_time: "",
  end_time: "",
};
export default {
  props: {
    type: String,
  },
  components: { PlusOutlined, InboxOutlined },
  setup(props) {
    const state = reactive({
      action: exportCodeBatchsforbidsTemplate(),
      fileList: [],
      visibleTemplate: false,
      vipList: [],
      listLoading: false,
      total: 0,
      visible: false,
      confirmLoading: false,
      exportResultVisible: false,
      exportResult: {},
    });
    let data = ref();
    const exportColumns = [
      {
        title: "批次",
        dataIndex: "batch_sn",
        key: "batch_sn",
      },
      {
        title: "流水号",
        dataIndex: "small_code",
        key: "small_code",
      },
      {
        title: "原因",
        dataIndex: "reason",
        key: "reason",
      },
    ];
    let columns = [
      {
        title: "批次",
        dataIndex: "batch_sn",
        key: "batch_sn",
      },
      {
        title: "码类型",
        dataIndex: "scenario_type_title",
        key: "scenario_type_title",
      },
      {
        title: "流水号区间",
        dataIndex: "small_serial",
        key: "small_serial",
        customRender: ({ text, record }) => {
          return record.small_serial_start + "-" + record.small_serial_end;
        },
      },
      {
        title: "数量",
        dataIndex: "small_code_counts",
        key: "small_code_counts",
      },
      // {
      //   title: "禁用数量",
      //   dataIndex: "point",
      //   key: "point",
      // },
      {
        title: "添加时间",
        dataIndex: "created_time",
        key: "created_time",
      },
      // {
      //   title: "应用场景",
      //   key: "action",
      //   customRender: ({ text, record }) => {
      //     return "--";
      //   },
      // },
      {
        title: "生码说明",
        dataIndex: "remarks",
        key: "remarks",
        customRender: ({ text, record }) => {
          return record.remarks ? record.remarks : "-";
        },
      },
    ];

    if (props.type == "ban") {
      columns = [
        {
          title: "批次",
          dataIndex: "batch_sn",
          key: "batch_sn",
        },
        {
          title: "流水号区间",
          dataIndex: "small_serial",
          key: "small_serial",
          customRender: ({ text, record }) => {
            return record.small_serial_start + "-" + record.small_serial_end;
          },
        },
        {
          title: "禁用数量",
          dataIndex: "small_code_counts",
          key: "small_code_counts",
        },
        {
          title: "添加时间",
          dataIndex: "created_time",
          key: "created_time",
        },
        // {
        //   title: "应用场景",
        //   key: "action",
        //   customRender: ({ text, record }) => {
        //     return "--";
        //   },
        // },
        {
          title: "备注说明",
          dataIndex: "remarks",
          key: "remarks",
          customRender: ({ text, record }) => {
            return record.remarks || "-";
          },
        },
        {
          title: "操作",
          dataIndex: "action",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
    }
    const initData = async () => {
      state.listLoading = true;
      var res;
      if (props.type == "ban") {
        res = await codeBatchsforbids(search.value).then((res) => res.data);
      } else {
        res = await code_batchs(search.value).then((res) => res.data);
      }
      state.listLoading = false;
      if (iscode(res)) {
        data.value = res.data;
        state.total = res.meta.total;
      }
      state.listLoading = false;
    };
    const search = ref({ ...def });
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const changTime = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    onMounted(() => {
      initData(search.value);
    });

    const $Modal = inject("$Modal");
    // 启用
    const open = async (data) => {
      $Modal.confirm({
        centered: true,
        content: `您确定要启用吗？`,
        onOk: async () => {
          let result = await codeBatchsforbidsStatus(data.id, { is_forbid: 0 })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
            pageSearchChange();
          }
        },
      });
    };
    // 添加禁用
    const banForm = ref({
      forbid_type: 1,
      remarks: "",
      batch_sns: [],
      small_serial_start: "",
      small_serial_end: "",
      batch_sn: "",
    });
    const banVisible = ref(false);
    const addBanBatch = () => {
      banVisible.value = true;
      banForm.value = {};
    };

    // 用于记录 选中的批次 数据
    const batch = ref();
    const batchChange = (data) => {
      batch.value = data;
    };
    // 添加禁用确定
    const banConfirm = async () => {
      if (!banForm.value.batch_sn) {
        message.error("请选择批次");
        return;
      }
      if (!banForm.value.remarks) {
        message.error("请输入备注");
        return;
      }
      if (!banForm.value.forbid_type) {
        message.error("请选择类型");
        return;
      }
      if (
        banForm.value.forbid_type == 2 &&
        (!banForm.value.small_serial_start || !banForm.value.small_serial_end)
      ) {
        message.error("请设置流水号区间");
        return;
      }
      var batch_sns = [banForm.value.batch_sn];
      state.confirmLoading = true;
      let result = await createforbids({ ...banForm.value, batch_sns })
        .then((res) => res.data)
        .catch((error) => error);
      state.confirmLoading = false;
      if (iscode(result, true)) {
        banVisible.value = false;
        pageSearchChange();
      }
    };
    // 同步数据
    const asyncBatch = async () => {
      let result = await codeBatchsSync()
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        initData(search.value);
      }
    };
    const handleChange = (e) => {
      console.log(e);
      if (e.file.status != "removed") {
        console.log(e.file.response);
        if (e.file.response && e.file.response.code == 0) {
          state.exportResult = e.file.response.data;
          if(!state.exportResult.error_data.length){
          Modal.confirm({
              centered: true,
              title: '导入结果',
              content: `本次导入${state.exportResult.total}条，成功${state.exportResult.success_total}条，失败${state.exportResult.error_total} 条`
          })
          }else{
          state.exportResultVisible = true;
          }
        } else {
          message.error(e.file.response.message);
          e.fileList[e.fileList.length - 1].status = "error";
          return false;
        }
      }
    };
    const exportTable = async () => {
      const hide = message.loading("正在加载中...", 0);
      let result = await codeBatchsforbidsTemplate()
        .then((res) => res.data)
        .catch((error) => error);
      setTimeout(hide);
      if (iscode(result, true)) {
        window.open(result.data.url);
      }
      console.log(result);
    };
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      changTime,
      open,
      addBanBatch,
      banVisible,
      banConfirm,
      banForm,
      batchChange,
      batch,
      verifyBatch,
      asyncBatch,
      getToken,
      exportTable,
      handleChange,
      exportColumns,
    };
  },
};
</script>